import { faEdit, faEllipsisVertical, faEye, faMessage } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { useState } from 'react';
import { Button, Dropdown, OverlayTrigger, Table, Tooltip } from 'react-bootstrap';
import CustomToggle from '../Menu/CustomMenu';
import BooleanStatus from '../status/BooleanStatus';
import EditApprovalModal from '../Modals/EditApproval.modal';
import { useParams } from 'react-router-dom';

interface ICenterApprovals {
  approvals: any[]
  reload: any,
  approvalValidUpto: any
}

export default function CenterApprovals(props: ICenterApprovals) {


  const params = useParams();

  const [approvalIndex, setApprovalIndex] = useState<number>(-1)

  console.log(props.approvalValidUpto, "approvalValidUpto 1")


  const renderTooltip = (props: any) => (
    <Tooltip id="button-tooltip" {...props}>
      {props}
    </Tooltip>
  );


  return (
    <>
      <Table borderless striped>
        <thead>
          <tr>
            <th>Sr. No</th>
            <th>Approval Id</th>
            <th>Visited</th>
            <th>Complete Status</th>
            <th>Total Nodes</th>
            <th>Approved On</th>
            <th>Approved Nodes</th>
            <th>Labs Approved</th>
            <th>Audit Reports</th>
            <th>Audit Remarks</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {
            props.approvals && props.approvals.length > 0 ?
              props.approvals.map((data: any, index: number) => {
                return (
                  <tr className="xcn-table-tr" key={data._id}>
                    <td>{index + 1}</td>
                    <td className="fw-bold xcn-text-12">
                      {data && data.approvalId}
                    </td>
                    <td>
                      <BooleanStatus
                        status={data && data.visited}
                        value={{
                          true: "Visited",
                          false: "Not Visited",
                        }}
                      />
                    </td>
                    <td>
                      <BooleanStatus
                        status={data && data.approved}
                        value={{
                          true: "Approved",
                          false: "Waiting",
                        }}
                      />
                    </td>
                    <td className="font-monospace xcn-text-12">
                      {data && data.nodesAvailable}
                    </td>
                    <td className="fw-bold font-monospace xcn-text-12 text-secondary">
                      {moment(data && data.approvedOn).format(
                        "DD-MM-YYYY"
                      )}
                    </td>
                    <td>{data && data.nodesApproved}</td>
                    <td>{data && data.numberofLabsApproved}</td>
                    <td>
                      {data && data.auditReport ? (
                        <a
                          className="text-decoration-none"
                          href={data && data.auditReport}
                          download
                        >
                          Preview
                        </a>
                      ) : (
                        "--"
                      )}
                    </td>
                    <td>
                      {data && data.remarks ? (
                        <OverlayTrigger
                          placement="right"
                          delay={{ show: 250, hide: 400 }}
                          overlay={renderTooltip(data && data.remarks)}
                        >
                          <span>
                            <FontAwesomeIcon
                              icon={faMessage}
                              className="text-primary"
                            />
                          </span>
                        </OverlayTrigger>
                      ) : (
                        "--"
                      )}
                    </td>
                    <td>
                      <Dropdown>
                        <Dropdown.Toggle
                          as={CustomToggle}
                          id="dropdown-custom-components"
                        >
                          <FontAwesomeIcon
                            icon={faEllipsisVertical}
                          />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => setApprovalIndex(index)}>
                            <FontAwesomeIcon
                              icon={faEdit}
                              className="text-info xcn-link-pointer"
                            />
                            <span className="fw-bold text-secondary fs-12 ms-2">
                              Edit
                            </span>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                );
              }) :
              <tr>
                <td colSpan={8} className="text-danger fw-bold">
                  No Approvals Registered
                </td>
              </tr>
          }

        </tbody>
      </Table>

      <EditApprovalModal
        show={approvalIndex >= 0 ? true : false}
        onClose={() => setApprovalIndex(-1)}
        data={props.approvals && props.approvals[approvalIndex]}
        reload={props.reload}
        approvalValidUpto={props.approvalValidUpto}
        centerId={params.centerId}
      />
    </>
  )
}